import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ILoadGeneral } from '../models';
import { GeneralSchema } from '../schemas';

export const useGeneral = () => {
  const form = useForm<ILoadGeneral | any>({
    resolver: yupResolver(GeneralSchema),
    defaultValues: {
      tax_number: '',
    },
  });

  return {
    form,
  };
};
